$(function($) {
  $.widget("ui.ipsBasicLayout", {
    _create: function() {
      this.options.layout(this);
      this._super();
    },
    addControl: function(control, options) {
      control.css({
        position: options.position,
        left: options.left,
        top: options.top
      });
    },
    isRTL: function() {
      return false;
    },
    calculateSizes: function(control) {
      var type = control.getType();
      var options = control.options;
      var inputWidth = 0;
      var labelWidth = 0;
      if (
        type == "ipsTextbox" ||
        type == "ipsDropDownbox" ||
        type == "ipsTextboxProxy" ||
        type == "ipsDropDownboxProxy"
      ) {
        var offset = 0;
        //Textbox has a padding of 10 (5 on right, 5 on left)
        if (
          options.labelAboveEditArea ||
          options.hideLabel ||
          parseInt(options.labelOffset) <= 1
        )
          offset += themeDefinition.width.inputbox.paddingNoLabel;
        else if (!options.multiLine)
          offset += themeDefinition.width.inputbox.singleLine;
        //inforHyperlink adds padding
        if (options.infoViewer) {
          if (!options.labelAboveEditArea)
            offset += themeDefinition.width.inputbox.infoViewer.padding;
          else offset += 0;
        }
        //Calculates the width of the label
        labelWidth = this._calculateLabelWidth(type, options);
        // if the label is above the input field then it does not effect the width of the input
        if (!options.labelAboveEditArea) {
          offset += (labelWidth == "auto" ? 0 : labelWidth);
          if (labelWidth > 0) {
            if (options.multiLine)
              offset += themeDefinition.width.inputbox.labelOffset.multiLine;
            else
              offset += themeDefinition.width.inputbox.labelOffset.singleLine;
          } else {
            if (options.required && !options.suppressRequiredIndicator) {
              //if there is no label or label offset add room for indicator
              offset += themeDefinition.width.inputbox.required;
              if (type == "ipsDropDownbox" || type == "ipsDropDownboxProxy") {
                offset += themeDefinition.width.dropDownBox.requiredNoLabel;
              }
            }
          }
        }
        if (options.hasPopup) {
          //Popup adds 16 to the padding of the textbox
          offset += themeDefinition.width.inputbox.hasPopup;
        }
        if (type == "ipsDropDownbox" || type == "ipsDropDownboxProxy") {
          offset += themeDefinition.width.dropDownBox.padding;
        }
        if (options.justify && options.justify == "right") offset += 1;
        inputWidth = parseInt(options.width) - offset;
      }
      return {
        input: inputWidth,
        label: labelWidth.toString().toLowerCase() == "auto" ? labelWidth : labelWidth > 8 ? labelWidth - 8 : labelWidth
      };
    },
    _calculateLabelWidth: function(type, options) {
      var width = 0;
      var labelOffset = (typeof options.labelOffset == "undefined") ? parseInt(options.labelOffset) : options.labelOffset.toString().toLowerCase() == "auto" ? options.labelOffset : parseInt(options.labelOffset);
      if (
        type == "ipsTextbox" ||
        type == "ipsDropDownbox" ||
        type == "ipsTextboxProxy" ||
        type == "ipsDropDownboxProxy"
      ) {
        if (!options.hideLabel) {
          if (labelOffset > 0 || labelOffset.toString().toLowerCase() == "auto") width = labelOffset;
          else if (options.labelText && options.labelText.length > 0) {
            if (options.width >= 50) width = 50;
            else width = parseInt(options.width);
          }
        }
        //if (width == 0 && options.required && !options.suppressRequiredIndicator)
        //    width = 1;
        //if (options.required && !options.suppressRequiredIndicator)
        //    width += 1;
        //if (options.infoViewer)
        //    width -= 2;
      }
      return width;
    },
    _calculateFirstNodeWidth: function(dim, node, scrollLeft) {
      return dim.width - node.offsetLeft + scrollLeft;
    },
    _getNodeLeftPosition: function(node, $node) {
      return $node.position().left;
    },
    _getNodeWidth: function(parent, position, parentPadding) {
      return parent - position - parentPadding;
    },
    _getOffsetLeft: function(dim, node) {
      return node.offsetLeft;
    },
    // calculates the width needed for follow right edge
    calculateFollowEdgeWidth: function(node, parentNode) {
      //Get scroll width for procedures below.
      var scrollWidth = _getScrollBarWidth(node);
      // if the parent node is not given then we will attempt to find it
      if (!parentNode) {
        parentNode = findParentContainer(node);
      }
      //PC - needs to load within the node's context
      var $node = $(node, node.document);
      var w = 0;
      if (parentNode == document.body) {
        var dim = GetDocumentDim();
        //Chrome and FF use document.body, IE uses dodument.documenElement
        var scrollLeft =
          document.documentElement.scrollLeft == 0
            ? document.body.scrollLeft
            : document.documentElement.scrollLeft;
        w = this._calculateFirstNodeWidth(dim, node, scrollLeft);
        // calculate if there is going to be a scrollbar and if is then take that into account
        if (
          document.body.scrollHeight == dim.height &&
          node.scrollHeight > dim.height
        ) {
          w -= scrollWidth;
        }
        document.body.setAttribute("calculatedWidth", w);
      } else {
        var position = 0;
        try {
          position = this._getNodeLeftPosition(node, $node);
        } catch (err) {
          log(err, "error");
        }
        var parent = parentNode.clientWidth;
        var parentPadding = 0;
        if (
          parentNode.getAttribute("isGridOuter") ||
          parentNode.getAttribute("isTableLayoutGroup") ||
          parentNode.getAttribute("isAttachOuter") ||
          (parentNode.className &&
            parentNode.className.indexOf("SubProcessBoxMain") != -1)
        ) {
          parentPadding = 2;
        }
        w = this._getNodeWidth(parent, position, parentPadding);
        //Srcoll bar is hidden behind edge if the node height > node scrollheight
        //Compensates for the addition of a scroll bar for containers/subforms
        if (node.scrollHeight > node.clientHeight) {
          w -= scrollWidth * 0.85; //85% of the calculated scroll bar width appears to be the most aesthetically pleasing spacing necessary to show the scroll bar
        }
      }
      if (
        node.getAttribute("isAttachOuter") ||
        (node.className && node.className.indexOf("SubProcessBoxMain") != -1)
      ) {
        w -= 4;
      }
      if (
        parentNode.getAttribute("isGridOuter") &&
        parentNode.getAttribute("noPadding")
      ) {
        w += 4;
      }
      if (node.className.indexOf("inforPanelItem") > -1) {
        w -= window.themeDefinition.width.ipsTilePanel.item;
      }
      // if the offsetParent is not this node's parentNode then that means there is another
      // element inbetween our current node and the parentNode that is effecting our left
      // position.  Take into account the offsetParent's left position also
      if (node.offsetParent && parentNode != node.offsetParent) {
        var parentLeft = this._getOffsetLeft(
          { width: parentNode.offsetWidth },
          node.offsetParent
        );
        if (parentLeft > 0) {
          w -= parentLeft;
        } else if (parentNode.getAttribute("isTabPane")) {
          // if the parent node is a tabpane and the offset parent is NOT the tabpane then that means we have a DIV inbetween
          // the tabpage and this node and that DIV does not have any positioning info however we still have a 22px padding
          // that we need to account for.  This can be see in Work Management Activity Workflow Info Viewer
          w -= 22;
        }
        // the width of this extra element could cause an overflow, reset the width
        // to auto to ensure that it is never it too big thereby causing scrollbars
        // this could happen with the following markup:
        // <body>
        // 	   <div style='position:absolute;top:56px;width:100%'>
        //		    <htc:groupbox style='position:relative; top:5px;">
        if (
          node.offsetParent != document.body &&
          node.offsetParent.className != "inforFieldSet" &&
          !node.offsetParent.getAttribute("isGroupBoxContainer")
        ) {
          node.offsetParent.style.width = "";
          node.offsetParent.style.overflow = "visible";
        }
      }
      // if there is a min-width on this control lets take that into account.  Our width can't be less than the min-width
      if (node.style.minWidth && node.style.minWidth !== "") {
        var minWidth = parseInt(node.style.minWidth, 10);
        if (w < minWidth) {
          w = minWidth;
        }
      }
      return w;
    }
  });
});
